import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ReactNode} from 'react'
import {StyledUserAddressCardWrapper, StyledUserAddressCardSubtitle, StyledUserAddressCardTitle} from './style'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

interface UserAddressCardProps {
    icon: ReactNode
    title?: string
    subtitle?: string
    kicker: string
    border?: 'left' | 'right'
    isLoading?: boolean
    isError?: boolean
}

export const UserAddressCard = ({icon, title, subtitle, kicker, border, isLoading, isError}: UserAddressCardProps) => {
    return (
        <StyledUserAddressCardWrapper gap={1} fullWidth $border={border}>
            {isLoading ? (
                <>
                    <Skeleton width={20} height={20} />
                    <Flexbox direction="column" gap={0.5} fullWidth>
                        <Skeleton height={20} />
                        <Skeleton height={20} />
                    </Flexbox>
                </>
            ) : (
                <>
                    {icon}
                    <Flexbox direction="column" gap={1} fullWidth>
                        <p>{kicker}</p>
                        <Flexbox direction="column" gap={0.5} fullWidth>
                            <StyledUserAddressCardTitle $hasError={!!isError}>{title}</StyledUserAddressCardTitle>
                            {subtitle && <StyledUserAddressCardSubtitle>{subtitle}</StyledUserAddressCardSubtitle>}
                        </Flexbox>
                    </Flexbox>
                </>
            )}
        </StyledUserAddressCardWrapper>
    )
}
